<template>
  <form-item labelAlign="left" labelWidth="80" label="跳转方式" tip="页面打开的类型">
    <el-radio-group
        @change="pageTypeChange"
        v-model="option.openType"
        :data-test="!option.openType && (option.openType = OPEN_PAGE_TYPE.DIALOG)"
    >
      <el-radio-button :label="OPEN_PAGE_TYPE.DIALOG" v-if="editorType !== 1">弹窗</el-radio-button>
      <el-radio-button :label="OPEN_PAGE_TYPE.DRAW" v-if="editorType !== 1">抽屉</el-radio-button>
      <el-radio-button :label="OPEN_PAGE_TYPE.INNER" v-if="editorType === 1">刷新页面</el-radio-button>
      <el-radio-button :label="OPEN_PAGE_TYPE.TAB">新标签</el-radio-button>
      <el-radio-button :label="OPEN_PAGE_TYPE.COVER" v-if="editorType !== 1">覆盖</el-radio-button>
    </el-radio-group>
  </form-item>
  <form-item labelAlign="left" :label-width="80" label="选择菜单"
             label-width="90">
    <el-tree-select filterable @node-click="handleNodeClick" placeholder="请选择"
                    v-model="option.aidaPageId" :data="menus"/>
  </form-item>
  <form-item
      v-if="option.openType === OPEN_PAGE_TYPE.TAB || option.openType === OPEN_PAGE_TYPE.INNER"
      tip="自动获取的路由，请勿随意修改，当业务侧自定义路由时才需要修改此项"
      labelAlign="left"
      :label-width="80"
      label="跳转路由"
      label-width="90"
  >
    <el-input v-model="option.jumpRoute"></el-input>
  </form-item>
  <form-item v-if="option.openType === OPEN_PAGE_TYPE.DRAW" labelAlign="left" labelWidth="80" label="打开类型"
             tip="抽屉的方向">
    <el-radio-group v-model="option.drawDir"
                    :data-test="!option.drawDir && (option.drawDir = DRAW_DIR.LEFT)">
      <el-radio-button :label="DRAW_DIR.UP">向上</el-radio-button>
      <el-radio-button :label="DRAW_DIR.DOWN">向下</el-radio-button>
      <el-radio-button :label="DRAW_DIR.LEFT">向左</el-radio-button>
      <el-radio-button :label="DRAW_DIR.RIGHT">向右</el-radio-button>
    </el-radio-group>
  </form-item>
  <form-item
      v-if="option.openType === OPEN_PAGE_TYPE.DRAW || option.openType === OPEN_PAGE_TYPE.DIALOG"
      labelAlign="left"
      tip="弹窗或者抽屉的标题"
      labelWidth="80"
      label="标题"
  >
    <el-input v-model="option.openTitle"></el-input>
  </form-item>
  <template v-if="option.openType === OPEN_PAGE_TYPE.DIALOG || option.openType === OPEN_PAGE_TYPE.DRAW">
    <form-item labelAlign="left" labelWidth="80" label="宽度"
               tip="弹窗或者抽屉的宽度，可输入数字字符串，如 100 100px 50%">
      <el-input v-model="option.openWidth"></el-input>
    </form-item>
    <form-item labelAlign="left" labelWidth="80" label="高度"
               tip="弹窗或者抽屉的高度，可输入数字字符串，如 100 100px 50%">
      <el-input v-model="option.openHeight"></el-input>
    </form-item>
  </template>
</template>
<script setup>
import {computed, inject, ref} from "vue";

let props = defineProps({
  option: {},
  showPageSelect: {
    type: Boolean,
  },
  app: {},
});
import {DRAW_DIR, OPEN_PAGE_TYPE} from "@/option/common/dict";
import {appMenuDao, sceneDao} from "@/option/common/dao";

let editorType = inject("editorType");
// 大屏
if (editorType === 1 && !props.option.openType) {
  props.option.openType = OPEN_PAGE_TYPE.TAB
}
getMenus();
getSceneList()

let menuRes = ref([])
let sceneRes = ref([])
let menus = computed(() => {
  let list = (props.option.openType === OPEN_PAGE_TYPE.TAB || props.option.openType === OPEN_PAGE_TYPE.INNER) ? menuRes.value : sceneRes.value;
  return list
})

function getMenus() {
  appMenuDao
      .getMenus({
        appId: props.app.id,
        version: props.app.currentVersion,
      })
      .then((el) => {
        handledSavedMenu(el);
        menuRes.value = el
      });
}

function getSceneList() {
  sceneDao
      .listByAppId({
        appId: props.app.id,
        version: props.app.currentVersion,
      })
      .then((res) => {
        handledSceneMenu(res);
        sceneRes.value = res
      });
}

function handledSceneMenu(list) {
  list?.forEach((el) => {
    // 找到就删除
    el.label = el.name || el.componentName;
    el.value = el.id;
    if (el.pageComponentDtoList) {
      el.children = el.pageComponentDtoList;
    }
    if (el?.children?.length) {
      handledSceneMenu(el.children);
    }
  });
}

function handledSavedMenu(list) {
  list.forEach((el) => {
    // 找到就删除
    el.label = el.showName;
    el.value = el.path;
    if (el?.children?.length) {
      handledSavedMenu(el.children);
    }
  });
}

// 查找对应的页面所对应的路由
function pageTypeChange() {
  props.option.aidaPageId = ''
  if (props.option.openType === OPEN_PAGE_TYPE.TAB) {
    let node = getRoute(menus.value);
    let p;
    if (node.parent) {
      p = `${node.parent.path}/`;
    }
    p += node.path;
    props.option.jumpRoute = p;
  }
}

function getRoute(list, res) {
  if (list?.length) return;
  list.forEach((el) => {
    if (el.uri === props.option.actionContent) {
      res = el;
    } else if (el?.children?.length && !res) {
      el.children.forEach((_el) => {
        _el.parent = el;
      });
      res = getRoute(el.children, res);
    }
  });
  return res;
}

function handleNodeClick(data, node) {
  let p;
  if (node.parent) {
    p = `${node.parent.data.path}/`;
  }
  p += node.data.path;
  props.option.aidaPagePath = p;
  // uri是菜单那边保存页面id的字段
  props.option.aidaPageId = data.uri || data.id;
}
</script>
<style scoped lang="scss"></style>
